import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ColDef, NestedFieldPaths } from 'ag-grid-community';

@Injectable()
export class ColumnFactory<TModel> {
  private readonly translateService = inject(TranslateService);

  create(
    field: NestedFieldPaths<TModel, unknown, []>,
    headerNameKey: string,
    options: Partial<ColDef> = {},
    cellRenderer?: unknown,
    cellStyle: ColDef['cellStyle'] = { border: 'none' }
  ): ColDef {
    return {
      field,
      headerName: this.translateService.instant(headerNameKey),
      cellRenderer,
      cellStyle,
      ...options,
    };
  }
}
